<script>
	import "chota";
	import { Router, Route } from "svelte-routing";
	import Root from "./RootPage.svelte";
	import Projects from "./projects/AllProjectsPage.svelte";
	import DDW from "./ddw/DDWPage.svelte";
	import Support from "./support/EpicappSupport.svelte";
	import AmbaSupport from "./support/AmBaSupport.svelte";
	import Upwork from "./pages/UpworkPage.svelte";
	export let url = ""; //This property is necessary declare to avoid ignore the Router
</script>

<Router {url}>
	<div>
		<Route path="projects" component={Projects} />
		<Route path="daily-decision-wheel" component={DDW} />
		<Route path="support" component={Support} />
		<Route path="amba-support" component={AmbaSupport} />
		<Route path="upwork" component={Upwork} />
		<Route path="/"><Root /></Route>
	</div>
</Router>
